import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveDocumentsDetail } from 'src/services/documents.service';
import { transformFormValues } from 'src/helpers';
import documentsActions from '../state/documentsActions';
import DocumentInfoPres from 'src/ui/features/Documents/presentational/DocumentInfoPres';
import { withSnackbar } from 'notistack';
import intl from 'react-intl-universal';
import {
  isApplicantSelector,
  isCorpClientSelector,
  isRestrictedCorpMemberSelector,
  isCorporateClientLineManagerSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { openDocumentsTab } from 'src/ui/features/Documents/state/documentsActions';
import { formDataDifference } from 'src/helpers/formDataDifference.js';

export class DocumentInfoContainer extends Component {
  state = {
    formDetails: {},
    casePhases: {},
    isEditable: false,
    showCancelEditlModal: false,
    showDeleteModal: false,
    accessCorporateClient: false,
    accessCorporateClientLineManager: false,
    accessEmployee: false,
    accessEyProfessional: false,
    formData: {},
    isEditBtnDisable: false,
    initialFormData: {},
  };

  componentDidMount() {
    const { documentId } = this.props.match.params;
    this.props.getDetails(documentId);
    this.formValues = null;
    // this.externalUser = null;
  }

  setDocumentAccess = () => {
    const { corporateClient, employee, eyProfessional, corporateClientLineManager } = this.props.docState.documentDetail.documentAccess;
    this.setState({
      accessCorporateClient: corporateClient,
      accessEmployee: employee,
      accessEyProfessional: eyProfessional,
      accessCorporateClientLineManager: corporateClientLineManager,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.docState !== prevProps.docState) {
      if (this.props.docState.documentDetail.hasOwnProperty('documentInformation')) {
        //this.setDocumentAccess();
      }
    }
  }

  // handleEditButtonForExternalUsers = () => {
  //   console.log (this.props);
  //   const { isApplicant, isCorpClient, isRestrictedCorpMember, isCorporateClientLineManager } = this.props;
  //   if ([isApplicant, isCorpClient, isRestrictedCorpMember, isCorporateClientLineManager].includes(true)) {
  //     this.setState({ isEditBtnDisable: true });
  //   }
  // };

  handleEdit = () => {
    this.setState({ isEditable: true, initialFormData: this.state.formData });
  };

  toggleModal = status => {
    this.setState({
      showCancelEditlModal: status,
      showDeleteModal: status,
    });
  };

  toggleEditModal = status => {
    this.setState({
      showCancelEditlModal: status,
    });
  };

  handleFormChange = data => {
    this.setState({
      formData: data,
    });
  };

  handleCancel = () => {
    this.setState({
      showCancelEditlModal: false,
      showDeleteModal: false,
      isEditable: false,
    });

    //this.setDocumentAccess();
  };

  handleDelete = target => {
    this.setState({
      showDeleteModal: true,
    });
  };

  onDocumentAccessChanged = value => {
    this.setState({
      [value]: !this.state[value],
    });
  };

  onConfirmDelete = () => {
    const { documentId } = this.props.match.params;
    const { deleteDocument, history } = this.props;

    deleteDocument(
      documentId,
      'Updated Successfully.',
      () => {
        this.handleCancel();
        history.goBack();
        this.props.openDocumentsTab();
      },
      () => {},
    );
  };

  handleSave = async () => {
    const { documentDetailId } = this.props.docState;
    const { formValues } = this.state.formData;

    formValues.dataRequests =
      Object.keys(this.state.initialFormData).length > 0
        ? formDataDifference(formValues.dataRequests, this.state.initialFormData.formValues.dataRequests)
        : formValues.dataRequests;

    const data = {
      entityId: documentDetailId,
      ...transformFormValues(formValues),
    };

    const result = await saveDocumentsDetail(data);

    if (result && !result.error) {
      // reload the data
      const { documentId } = this.props.match.params;
      await this.props.getDetails(documentId);
      this.setState({ isEditable: false });
      this.props.history ? this.props.history.goBack() : window.location.reload();
      this.props.enqueueSnackbar(intl.get('documents.documentDetails.messages.successMessage'), { variant: 'success' });
    }
  };

  render() {
    return (
      <DocumentInfoPres
        documentId={this.props.match.params.documentId}
        documentKey={this.props.match.params.documentKey}
        employeeGUID={this.props.empGUID}
        docState={this.props.docState}
        documentDetail={this.props.documentDetail}
        onFormChange={this.handleFormChange}
        showCancelEditlModal={this.state.showCancelEditlModal}
        showDeleteModal={this.state.showDeleteModal}
        onEdit={this.handleEdit}
        onCancel={this.toggleEditModal.bind(null, true)}
        onCancelModal={this.handleCancel}
        onConfirmModal={this.toggleModal.bind(null, false)}
        onConfirmDeleteModal={this.onConfirmDelete}
        onSave={this.handleSave}
        isEditable={this.state.isEditable}
        isEditButtonDisabled={this.state.isEditBtnDisable}
        onDelete={this.handleDelete}
        getDocument={this.props.getDocument}
        onDocumentAccessChanged={this.onDocumentAccessChanged}
        isApplicant={this.props.isApplicant}
        isCorpClient={this.props.isCorpClient}
        isRestrictedCorpMember={this.props.isRestrictedCorpMember}
        isCorporateClientLineManager={this.props.isCorporateClientLineManager}
        accessCorporateClient={this.state.accessCorporateClient}
        accessEmployee={this.state.accessEmployee}
        accessEyProfessional={this.state.accessEyProfessional}
        openDocument={this.props.openDocument}
        accessCorporateClientLineManager={this.state.accessCorporateClientLineManager}
        formData={this.state.formData}
      />
    );
  }
}

const mapStateToProps = state => ({
  docState: state.documents,
  isApplicant: isApplicantSelector(state),
  isCorpClient: isCorpClientSelector(state),
  isRestrictedCorpMember: isRestrictedCorpMemberSelector(state),
  isCorporateClientLineManager: isCorporateClientLineManagerSelector(state),
  activeCaseManagerId: state.documents.activeCaseManagerId,
});

const mapDispatchToProps = {
  getDetails: documentsActions.getDocumentDetails,
  getDocument: documentsActions.getDocument,
  deleteDocument: documentsActions.deleteDocument,
  openDocument: documentsActions.openDocument,
  openDocumentsTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(DocumentInfoContainer));
